
import { ColumnsFactory } from "../../../../../../shared/components/Grid/functions";
import { DescargaCellRenderer } from "./DescargaCellRenderer";
import { VisualizarCellRenderer } from "./VisualizarCellRenderer";

const ActionColumns = (translate,dataFilter) => [
    ColumnsFactory.PopoverColumn(translate('visualizar'), "idFactura",{cellRendererFramework:(params)=>VisualizarCellRenderer(params)}),
    ColumnsFactory.PopoverColumn(translate('descargar'), "idFactura",{cellRendererFramework:(params)=>DescargaCellRenderer(params)})
  ]

export const getColumnDefs = (translate,dataFilter) => {
   
  return [
    ColumnsFactory.TextColumn(translate('factura'), "idFactura"),
    ColumnsFactory.NumericColumn(translate('año'), "anio"),
    ColumnsFactory.NumericColumn(translate('mes'), "mes"),
    ColumnsFactory.TextColumn(translate('tipo'), "tipoFactura"),
    ColumnsFactory.TextColumn(translate('referencia'), "referenciaFactura"),
    ColumnsFactory.TextColumn(translate('grupoFactura'), "grupoFactura"),
    ColumnsFactory.DateColumn(translate('fecha-facturacion'), "fechaFacturacion"),
    ColumnsFactory.DateColumn(translate('fecha-vencimiento'), "fechaVencimiento"),
    ColumnsFactory.GroupColumn(translate('acciones'), ActionColumns(translate), 'header-group-facturacion-expatriados-grid')
  ];
};